export default "__VITE_ASSET__ewKBIsQd__"